import APIV5 from '~/models/api';

/* globals Knitiv */

/**
 * @typedef {Object} Scope
 * @property {boolean} loading
 * @property {unknown} actions
 * @property {() => Promise<unknown>} loadActions
 */

export default class {
	/** @type {Knitiv.RootScope} */
	$rootScope;

	/** @type {undefined | boolean} */
	state;

	/* @ngInject */
	/**
	 * @param {Knitiv.Scope & Scope} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {Knitiv.RootScope} $rootScope
	 */
	constructor($scope, $timeout, $rootScope) {
		this.state = undefined;

		$scope.loadActions = async () => {
			$scope.loading = true;
			const content = await APIV5.instance.uiGetContent(
				{ path: 'HOME/ACTIONS' },
				{ id: 'home.dashboard.actions' },
			);
			$timeout(() => {
				$scope.actions = content.result;
				$scope.loading = false;
			});
		};

		this.$rootScope = $rootScope;

		$scope
			.loadActions()
			.then(() => {
				this.$rootScope.$emit('gridtsack.refresh-item', {
					widgetId: this.widgetId,
				});
				return true;
			})
			.catch(error => {
				console.error('e', error);
			});
	}

	/**
	 * @param {boolean} state
	 */
	onToggle(state) {
		this.state = state;
		let count = 5;
		// eslint-disable-next-line angular/interval-service
		const interval = setInterval(() => {
			if (count <= 0) {
				clearInterval(interval);
			}
			this.$rootScope.$emit('gridtsack.refresh-item', {
				widgetId: this.widgetId,
			});
			count -= 1;
		}, 100);
	}
}
